import {
  setCategoryBrands,
  setApiData,
  addItemToMyCart,
  numbersOfItems,
  notificationCart,
} from "./Reducers";
import { combineReducers } from "redux";

export const allReducers = combineReducers({
  setBrands: setCategoryBrands,
  setData: setApiData,
  addCart: addItemToMyCart,
  counterItems: numbersOfItems,
  notification: notificationCart,
});
